// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OperacaoServiceOrders_CategoriasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/operacao_service_orders/categorias.
 *
 * Per locked decision #4, service and product categorias are exposed as
 * TWO independent breakdowns (not unified) so the frontend can render
 * two distinct donut charts.
 *
 * `combos_vendidos_*` (NS 2026-0090): the prepaid combo SALE items of the
 * period — count and value (cents). The pairs they cover sit in the service
 * slice at 0, so the combo's revenue is counted once, here.
 */
import type { OperacaoServiceOrders_CategoriaRow } from './OperacaoServiceOrders_CategoriaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OperacaoServiceOrders_CategoriasResponseDados {
service_categorias: OperacaoServiceOrders_CategoriaRow[]
product_categorias: OperacaoServiceOrders_CategoriaRow[]
combos_vendidos_count: number
combos_vendidos_total_centavos: number
}

export type OperacaoServiceOrders_CategoriasResponse = ApiResponse<OperacaoServiceOrders_CategoriasResponseDados>;

registerResponseContract('OperacaoServiceOrders_CategoriasResponse', {
  service_categorias: {
    type: 'array',
    required: true,
    items: {
      category_id:     { type: 'number',  required: false },
      category_name:   { type: 'string',  required: true },
      items_count:     { type: 'number',  required: true },
      total_centavos:  { type: 'number',  required: true },
      via_combo_count: { type: 'number',  required: false },
    },
  },
  product_categorias: {
    type: 'array',
    required: true,
    items: {
      category_id:     { type: 'number',  required: false },
      category_name:   { type: 'string',  required: true },
      items_count:     { type: 'number',  required: true },
      total_centavos:  { type: 'number',  required: true },
      via_combo_count: { type: 'number',  required: false },
    },
  },
  combos_vendidos_count:          { type: 'number',  required: true },
  combos_vendidos_total_centavos: { type: 'number',  required: true },
})
